import { isEventInstance, LegacyPatientAppEvent, PatientAppEvent } from './AppEvent';
export const DISPLAY_HEALTH_CATEGORY_TREND_EVENT_NAME = 'display-health-category-trends';
export const HIDE_HEALTH_CATEGORY_TREND_EVENT_NAME = 'hide-health-category-trends';
export const NAVIGATE_TO_DASHBOARD_EVENT_NAME = 'navigate-to-dashboard';
export const PATIENT_APP_READY_TO_RECEIVE_EVENTS_NAME = 'patient-app-ready-to-receive';
export const SHOW_NEW_SIGNUP_FLOW_EVENT_NAME = 'show-new-signup-flow';
export const HIDE_NEW_SIGNUP_FLOW_EVENT_NAME = 'hide-new-signup-flow';
export const NEW_SIGNUP_FLOW_COMPLETE_EVENT_NAME = 'new-signup-flow-complete';
export const SHOW_NEW_CONNECT_FLOW_EVENT_NAME = 'show-new-connect-flow';
export const HIDE_NEW_CONNECT_FLOW_EVENT_NAME = 'hide-new-connect-flow';
export const NEW_CONNECT_FLOW_COMPLETE_EVENT_NAME = 'new-connect-flow-complete';
export const SHOW_LEGACY_TERMS_OF_SERVICE_EVENT_NAME = 'show-legacy-terms-of-service';
export const SHOW_LEGACY_SIGN_IN_EVENT_NAME = 'show-legacy-sign-in';
export const SHOW_LEGACY_CONTACT_US_EVENT_NAME = 'show-legacy-contact-us';
export const SHOW_LEGACY_FORGOT_PASSWORD_EVENT_NAME = 'show-legacy-forgot-password';
export const SHOW_LEGACY_FORGOT_USERNAME_EVENT_NAME = 'show-legacy-forgot-username';
export class PatientAppReadyToReceiveEvents extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: PATIENT_APP_READY_TO_RECEIVE_EVENTS_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, PATIENT_APP_READY_TO_RECEIVE_EVENTS_NAME);
    };
}
export class DisplayHealthCategoryTrendsEvent extends PatientAppEvent {
    constructor(healthCategory) {
        super({ eventName: DISPLAY_HEALTH_CATEGORY_TREND_EVENT_NAME, healthCategory: healthCategory });
    }
    static isInstanceOf = (object) => {
        return PatientAppEvent.isInstanceOf(object) && isEventInstance(object, DISPLAY_HEALTH_CATEGORY_TREND_EVENT_NAME);
    };
}
export class HideHealthCategoryTrendsEvent extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: HIDE_HEALTH_CATEGORY_TREND_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, HIDE_HEALTH_CATEGORY_TREND_EVENT_NAME);
    };
}
export class NavigateToDashboardEvent extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: NAVIGATE_TO_DASHBOARD_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, NAVIGATE_TO_DASHBOARD_EVENT_NAME);
    };
}
export class ShowNewSignupFlowEvent extends PatientAppEvent {
    constructor() {
        super({ eventName: SHOW_NEW_SIGNUP_FLOW_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return PatientAppEvent.isInstanceOf(object) && isEventInstance(object, SHOW_NEW_SIGNUP_FLOW_EVENT_NAME);
    };
}
export class HideNewSignupFlowEvent extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: HIDE_NEW_SIGNUP_FLOW_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, HIDE_NEW_SIGNUP_FLOW_EVENT_NAME);
    };
}
export class NewSignupFlowCompleteEvent extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: NEW_SIGNUP_FLOW_COMPLETE_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, NEW_SIGNUP_FLOW_COMPLETE_EVENT_NAME);
    };
}
export class ShowNewConnectFlowEvent extends PatientAppEvent {
    constructor() {
        super({ eventName: SHOW_NEW_CONNECT_FLOW_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return PatientAppEvent.isInstanceOf(object) && isEventInstance(object, SHOW_NEW_CONNECT_FLOW_EVENT_NAME);
    };
}
export class HideNewConnectFlowEvent extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: HIDE_NEW_CONNECT_FLOW_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, HIDE_NEW_CONNECT_FLOW_EVENT_NAME);
    };
}
export class NewConnectFlowCompleteEvent extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: NEW_CONNECT_FLOW_COMPLETE_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, NEW_CONNECT_FLOW_COMPLETE_EVENT_NAME);
    };
}
export class ShowLegacyTermsOfServiceEvent extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: SHOW_LEGACY_TERMS_OF_SERVICE_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, SHOW_LEGACY_TERMS_OF_SERVICE_EVENT_NAME);
    };
}
export class ShowLegacySignInEvent extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: SHOW_LEGACY_SIGN_IN_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, SHOW_LEGACY_SIGN_IN_EVENT_NAME);
    };
}
export class ShowLegacyContactUsEvent extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: SHOW_LEGACY_CONTACT_US_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, SHOW_LEGACY_CONTACT_US_EVENT_NAME);
    };
}
export class ShowLegacyForgotPasswordEvent extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: SHOW_LEGACY_FORGOT_PASSWORD_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, SHOW_LEGACY_FORGOT_PASSWORD_EVENT_NAME);
    };
}
export class ShowLegacyForgotUsernameEvent extends LegacyPatientAppEvent {
    constructor() {
        super({ eventName: SHOW_LEGACY_FORGOT_USERNAME_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyPatientAppEvent.isInstanceOf(object) && isEventInstance(object, SHOW_LEGACY_FORGOT_USERNAME_EVENT_NAME);
    };
}
